/**
 * Opens a print-ready window with the given HTML content.
 * title: shown in the print dialog
 * content: full HTML string for the document body
 */
export const printDocument = (title, content) => {
  const win = window.open('', '_blank', 'width=800,height=600');
  if (!win) return;
  win.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        <style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: Arial, sans-serif; color: #222; padding: 30px; }
          .header { text-align: center; border-bottom: 2px solid #1F3864; pb: 12px; margin-bottom: 20px; }
          .header h1 { font-size: 22px; color: #1F3864; margin-bottom: 4px; }
          .header p { font-size: 13px; color: #666; }
          .section { margin-bottom: 18px; }
          .section h3 { font-size: 14px; color: #1F3864; border-bottom: 1px solid #ddd; padding-bottom: 4px; margin-bottom: 10px; }
          .row { display: flex; gap: 20px; margin-bottom: 8px; }
          .field { flex: 1; }
          .field label { font-size: 11px; color: #888; display: block; margin-bottom: 2px; }
          .field span { font-size: 13px; font-weight: 600; }
          .badge { display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 12px; font-weight: 700; }
          .badge-pending { background: #fff3e0; color: #e65100; }
          .badge-approved { background: #e8f5e9; color: #2e7d32; }
          .badge-rejected { background: #fce4ec; color: #c62828; }
          .badge-admitted { background: #e8f5e9; color: #1b5e20; }
          table { width: 100%; border-collapse: collapse; font-size: 12px; }
          th { background: #1F3864; color: #fff; padding: 8px; text-align: left; }
          td { padding: 7px 8px; border-bottom: 1px solid #eee; }
          .footer { margin-top: 30px; text-align: center; font-size: 11px; color: #aaa; border-top: 1px solid #eee; padding-top: 10px; }
          .logo-row { display: flex; align-items: center; justify-content: center; gap: 12px; margin-bottom: 8px; }
          @media print {
            body { padding: 15px; }
            button { display: none; }
          }
        </style>
      </head>
      <body>
        ${content}
        <div class="footer">Cumming Tamil School — Generated on ${new Date().toLocaleDateString()}</div>
        <script>window.onload = function() { window.print(); }</script>
      </body>
    </html>
  `);
  win.document.close();
};

export const field = (label, value) =>
  `<div class="field"><label>${label}</label><span>${value || '—'}</span></div>`;

export const row = (...fields) => `<div class="row">${fields.join('')}</div>`;

export const section = (title, content) =>
  `<div class="section"><h3>${title}</h3>${content}</div>`;

export const schoolHeader = (docTitle, subtitle = '') => `
  <div class="header">
    <h1>Cumming Tamil School</h1>
    <p>Cumming, GA | contact@cummingtamilschool.org</p>
    <h2 style="font-size:18px;margin-top:10px;color:#244C77">${docTitle}</h2>
    ${subtitle ? `<p style="color:#666;font-size:13px">${subtitle}</p>` : ''}
  </div>
`;
